import React, { useState, useEffect, useRef } from 'react';
import "../firebase.js";
import Cookies from 'js-cookie';
import { Helmet } from "react-helmet";
import './login.css';
import { useNavigate } from "react-router-dom";
import { setupRecaptcha } from "../firebase";
import { Toast } from '../components_root/ToastContext.jsx';
import { Randomcode } from '../components_root/rendom_code.js';
import { Randomnumber } from '../components_root/rendom_number.js';
import { MdClose, MdEdit, MdMessage, MdVerifiedUser } from 'react-icons/md';
import { signInWithGoogle } from '../firebase.js';
import google from '../assets/google.png';
import CountryCodeSelect from '../body_root/CountryCodeSelect.js';
export default function Login() {
  const navigate = useNavigate();
  const [sendotppin, setSendotppin] = useState();
  const [otppin, setOtppin] = useState(sendotppin);
  const [resend, setResend] = useState("Resend");
  const [mobile, setMobile] = useState("");
  const [qr_otp, setqr_otp] = useState("");
  const [otp_send, setotp_send] = useState(false);
  const { Toastshow } = Toast();
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);
  const [countryCode, setCountryCode] = useState("+91");
  const [days, setDays] = useState(1);
  const mobileRef = useRef(null);
  const otpRef = useRef(null);
  useEffect(() => {
    setSendotppin(Randomnumber(6));
    mobileRef.current?.focus(); // ✅ works
  }, []);
  //
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setDays(90);
      } else {
        setDays(10);
      }
    };
    // Run once on mount
    handleResize();
    // Attach resize listener
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const [return_url, setReturnUrl] = useState("/");

  useEffect(() => {
    const sessionKey = Cookies.get("sessionkey");
    if (sessionKey) {
      navigate(-1);
      return;
    }
    // ✅ Read return URL from query params
    const params = new URLSearchParams(window.location.search);
    const url = params.get("return");

    setReturnUrl(url || "/");
  }, []); // 👈 run only once
  // Initialize Recaptcha
  useEffect(() => {
    setupRecaptcha();
  }, []);

  const signInWithGoogle_handler = async () => {
    try {
      const res = await signInWithGoogle(); // ❌ remove parameters

      if (res?.success) {

        // if (window.history.length > 1) {
        //   window.history.back();

        //   // Wait a bit then reload
        //   // setTimeout(() => {
        //   //   window.location.reload();
        //   // }, 300);

        // } else { 
        window.location.href = "/";
        // }

      } else {
        window.location.href = "/";
      }

    } catch (err) {
      Toastshow(err?.message || "Google sign-in failed");
    }
  };
 
  const [readyToPrint, setReadyToPrint] = useState(false);

  useEffect(() => {
    // generate immediately
    setqr_otp(Randomcode(16));
    // generate every 20 seconds
    const interval = setInterval(() => {
      setqr_otp(Randomcode(16));
    }, 20000); // 20,000 ms = 30 sec

    // cleanup on unmount
    return () => clearInterval(interval);
  }, [readyToPrint]); // ❌ remove navigate from dependency
  return (
    <div>

      <Helmet>
        <title>Sign in to your account and start enjoying personalized statuses.</title>

        <meta
          name="description"
          content="Aooz Status provides daily WhatsApp status messages including love status, sad status, funny status, and motivational quotes. Copy and share instantly."
        />

        <meta
          name="keywords"
          content="whatsapp status,
love status,
sad status,
funny status,
motivational status,
daily status quotes,
short status messages,
instagram caption"
        />

        <meta name="author" content="aooz" />
        <meta name="robots" content="index, follow" />

        {/* Canonical */}
        <link rel="canonical" href="https://aooz.in/login" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Login | Aooz Status | Love, Sad, Funny & Motivational WhatsApp Status"
        />
        <meta
          property="og:description"
          content="Aooz Status provides daily WhatsApp status messages including love status, sad status, funny status, and motivational quotes. Copy and share instantly."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://aooz.in/login" />
        <meta
          property="og:image"
          content="https://aooz.in/assets/logo.png"
        />


        <meta
          name="twitter:image"
          content="https://aooz.in/assets/logo.png"
        />
      </Helmet>

      <div className="container_roots " >
        <div className="container_size_info">
          <div className="form p-22 shade rounded shadow"  >
            <div className=" center text-hero-sub bold">
              Status.Aooz.in
            </div>
            <div className="flex-column">
              <div className='text-h2 center'>
Sign in to your account and start enjoying personalized statuses.
</div>
            </div>

            {/* <table>
              <tr>
                <td>
                  <div className="flex-column fcap">
                    <label>Mobile number</label>
                  </div>
                  <div className='items-back b-1 rounded' >
                    <table>
                      <tr>
                        <td width={100}>
                          <CountryCodeSelect
                            value={countryCode}
                            onChange={setCountryCode} />
                        </td>
                        <td>
                          <input
                            ref={mobileRef}
                            tabIndex={1}
                            disabled={otp_send}
                            type="tel"
                            className="p-2 text-h1 border-none bold"
                            placeholder="Enter Mobile number"
                            maxLength={10}
                            value={mobile}
                            onChange={(e) => setMobile(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                handleSendOTP();
                                //  otpRef.current?.focus(); // ✅ WORKS
                              }
                            }}
                          />
                        </td>
                        {otp_send === true && (
                          <td><MdEdit onClick={() => {
                            setotp_send(false);

                            setMobile("");
                          }} className='icon cursor' /></td>
                        )}
                      </tr>
                    </table>
                  </div>
                  {otp_send === true && (
                    <>
                      <div className="flex-column fcap m-top" > 
                        <label>OTP  password</label> 
                      </div>
                      <div >
                        <table>
                          <tr>
                            <td>
                              <input
                                type="tel"
                                ref={otpRef}
                                tabIndex={2}

                                className="p-2 text-h1 bold"
                                maxLength={8}
                                placeholder="Confirm your OTP"
                                required
                                value={otppin}
                                onChange={(e) => {
                                  setOtppin(e.target.value);

                                }}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    e.preventDefault(); // ⛔ prevent form reload
                                    handleVerifyOTP();
                                  }
                                }}
                              />
                            </td>
                            <td width={120}>
                              {otp_send && (
                                <div className="text-h3 p-11 curser center">
                                  {resend > 0 ? (
                                    <span>Resend  {resend}s</span>
                                  ) : (
                                    <span
                                      className="cursor p-11 curser center"
                                      onClick={handleSendOTP}
                                    >
                                      Resend OTP
                                    </span>
                                  )}
                                </div>
                              )}
                            </td>
                          </tr>
                        </table>


                      </div>
                    </>
                  )

                  }

                </td>

              </tr>
            </table> */}
            <div className='text-h3'>Log in to agree to the Terms and Conditions</div>
            {/* {!otp_send ? (
              <div
                onClick={handleSendOTP}
                className="button-ui text-h2 fill p-3 cursor"
              >
                <MdMessage className="icon" />
                {isSubmitDisabled ? "Send Processing.." : "Send OTP"}
              </div>
            ) : (
              <div
                onClick={handleVerifyOTP}
                className="button-ui text-h2 fill p-3 cursor"
              >
                <MdVerifiedUser className="icon" />
                {isSubmitDisabled ? "Verify Processing.." : "Verify OTP"}
              </div>
            )} */}

            <table className='table-fixed'>
              <tr>
                <td>
                  <div className="button-ui2 p-3 fill cursor" onClick={signInWithGoogle_handler}>
                    <img src={google} className='icon' /> Signin With Google</div>
                </td>
                <td>
                  <div className="button-ui2 p-3 fill cursor" onClick={() => window.location.href = "https://aooz.in"}><MdClose className='icon' />Cancel</div>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div id="recaptcha-container"></div>
      </div>
    </div >
  );
}
